
import { useState } from 'react';
import Drawer from 'react-modern-drawer';


export default function MemberListing(param: any) {

    const onCloseDrawer = () => {
        param.MemberListingChange();
    }

    const [ShowUnmatched,setShowUnmatched] = useState(false);

    return (
        <>
            <Drawer open={param.MemberListingOpen}
                onClose={onCloseDrawer}
                direction='right'
                className='react-drawer  allowHscroll allowVscroll'
                size={800}>


                <div className="box noBorderRadius noBorder ws-7 pull-right landing ">

                    <div className='ws-12 pm'>
                        <h1 className='ws-10 text-bold'> Matched Members</h1>
                        <a onClick={() => onCloseDrawer()} className="btn-xxs modalClose borderNone bgTransparent pull-right" style={{ position: "inherit" }}>
                            <i className="icon-close3 danger"></i>
                        </a>
                    </div>

                    <div className='ws-12   pm'>


                        <div className='ws-12 '>

                            <div className='ws-7 pull-left'>
                                <h2 className="mb">Filter contract list</h2>
                                <input type="text" className='ws-10 height45' placeholder='Search member' />
                                <button type="button" className="text-bold icon-btn edit width70 height45 pull-left" >Search </button>
                            </div>

                            <div className='ws-1 mtxl ptl pull-right'>
                                <button type="button" className="text-bold icon-btn info width70 height45 mr pull-right" >Export </button>
                            </div>

                            <div className='ws-3 mtxl ptl pull-right'>
                                <label className='ws-12'>Show unmatched performers</label>
                                <label className="switch mt">
                                    <input type="checkbox" name="creator" checked={ShowUnmatched} onChange={() => setShowUnmatched(!ShowUnmatched)} />
                                    {ShowUnmatched && <span className="slider round text-left white pm pts" >Yes</span>}
                                    {!ShowUnmatched && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>

                        </div>


                    </div>


                    <div className='ws-12 pm'>
                        <button type="button" className=" icon-btn close text-bold pull-right height40 width100" onClick={() => onCloseDrawer()}>Cancel</button>
                    </div>
                </div>
            </Drawer >
        </>
    );
}